// extracted by mini-css-extract-plugin
export default {"patientMessaging":"PortalManagement_patientMessaging__puWMa"};